<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { get_gen_2_component_channel_structure, real_id } from 'src/helpers/interface_helpers';
		import { format } from 'src/services/i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { Button, Checkbox, Text, toast } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);

	let settings = $settingsStore;
	const component = get_gen_2_component_channel_structure(device);
	let currentValue = settings?.[component]?.motor?.gesture ?? false;
	let enabled = currentValue;
	let cache = currentValue;
	let loading = false;

	const toggle = () => {
		enabled = !enabled;
	};

	const save = async () => {
		if (enabled === cache) return;

		loading = true;

		const params = {
			id: device.channel ?? 0,
			config: {
				motor: {
					gesture: enabled,
				},
			},
		};

		const res: SettingRequest = await gen2Request(device, 'Cover.SetConfig', params);

		if (res.isok) {
			if (!settings[component].motor) {
				settings[component].motor = {};
			}
			settings[component].motor.gesture = enabled;
			devices_settings.update_devices_settings(id, settings);
			cache = enabled;
			toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast', { default: 'Settings saved' }),
			});
		} else {
			enabled = cache;
			toast.open({ type: 'danger', title: $format('error_global') });
		}

		loading = false;
	};
</script>

<Text styleType="body-small" class="mb-s"
	>{$format('raex_gesture_control_description', {
		default: 'Pull by hand to initiate opening or closing.',
	})}
</Text>

<Checkbox
	id="checkbox-raex-gesture-control"
	checked={enabled}
	on:click={toggle}
	aria-label={$format('raex_gesture_control_enable', { default: 'Enable gesture control' })}
>
	{$format('raex_gesture_control_enable', {
		default: 'Enable gesture control',
	})}
</Checkbox>

<Button
	id="button-raex-gesture-save"
	class="mt-s"
	{loading}
	size="m"
	width="full"
	on:click={save}
	aria-label={$format('button_save', { default: 'Save' })}
>
	{$format('button_save')}
</Button>
